import { SortDirection } from 'src/app/services/api.services';
import { VisualChartRoleCategorisation, VisualChartRoleOptionsMap, PbiChartDataRoles, PbiChartDefaultDataRoles, VisualChartGetRoleOptions, PbiDataRole } from './data-role';
import { VisualType, VisualTypeOptions } from 'src/app/pbir/visuals/VisualType';
import { Visual } from 'src/app/pbir/visuals/Visual';
import { VisualStyle } from 'src/app/pbir/visuals/VisualStyle';

export interface VisualChartType<TOptions extends Visual.Options = Visual.Options> {
  name: string;
  alias: string;
  dataRoles: PbiChartDataRoles;
  defaultDataRoles: PbiChartDefaultDataRoles;

  sortingDataRoles: PbiDataRole[] | null;
  defaultSortDirection: SortDirection;

  title: string;
  icon: string;
  description?: string;

  previewImageUrl: string;
  previewWhiteImageUrl: string;
  previewRedImageUrl: string;
  previewGreyImageUrl: string;

  getDataRoleOptions: (params: VisualChartGetRoleOptions) => VisualChartRoleOptionsMap;

  roleCategorisation: VisualChartRoleCategorisation;

  hidden?: boolean;
  hiddenSortingRole?: string;

  disallowMeasuresWithDoNotSummarize?: boolean;

  sortingGroups?: VisualChartSortingGroup[];

  visualType: VisualType<TOptions, any, any, any>;
  visualTypeOptions?: VisualTypeOptions<TOptions>;
};

export interface VisualChartSortingGroup {
  order: number;
  name: string;
  title: string;
  dataRoles: PbiDataRole[];
  maxFields: number;

  /** Data role to add alternative sorting fields to, for things like 'Month Name' -> 'Month Number' conversion. */
  alternativeFieldSortingDataRole?: string;
};
